import React, { useLayoutEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { ChevronDown, ChevronRight } from '@carbon/icons-react';
import AnnotationDetailDrawer from '@components/Chat/ChatMenu/Viewer/components/AnnotationDetailDrawer';
import { Spotlight, useSpotlight } from '@components/Spotlight';
import { colorSet } from '@components/Provider';
import FakeChat from '../FakeChat';
import { TutorialStepProps } from '../CapaViewTutorial';

const TutorialStep3 = ({
  handleNextStep,
  mockAnnotation
}: TutorialStepProps) => {
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const { load, targetRef, width, height } = useSpotlight();

  useLayoutEffect(() => {
    setTimeout(() => {
      (document.querySelector(
        '.comment-control-button'
      ) as HTMLElement)?.click();
    }, 10);
  }, []);
  const myName = mockAnnotation.comments?.[0].userName ?? '나';

  return (
    <>
      {load && targetRef.current && (
        <Spotlight
          cutOutTarget={matches ? { x: '50%', y: '100%' } : targetRef.current}
          radiusSize={matches ? 421 : 319}
          CTATitle={
            <Box display={'flex'} alignItems={'center'}>
              {matches ? (
                <>
                  주석과 답글 관리
                  <ChevronDown color={colorSet.primary500} size={26} />
                </>
              ) : (
                <>
                  주석과 답글 관리
                  <ChevronRight color={colorSet.primary500} size={26} />
                </>
              )}
            </Box>
          }
          CTADirection={matches ? 'top' : 'left'}
          CTADescription={
            '내가 남긴 주석과 답글을 수정하거나 삭제할 수도 있어요.'
          }
          handleNextStep={() => handleNextStep('4')}
          addX={matches ? 0 : -185}
          addY={matches ? -330 : 0}
          clientHeight={height}
          clientWidth={width}
        />
      )}
      {matches ? (
        <AnnotationDetailDrawer
          annotation={mockAnnotation}
          open={true}
          onClose={() => ({})}
        />
      ) : (
        <FakeChat myName={myName} isMenuOpen={true} ref={targetRef} />
      )}
    </>
  );
};

export default TutorialStep3;
